/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneTagsIndex from 'base/components/standalone/TagsIndex';

export const DynamicStandaloneTagsIndex = StandaloneTagsIndex;
export type DynamicStandaloneTagsIndexProps = PropsFromComponent<typeof StandaloneTagsIndex>;

export const DynamicStandaloneTagsIndexWith = (extras: DynamicStandaloneExtras): typeof StandaloneTagsIndex => {
    return function DynamicStandaloneTagsIndex(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'TagsIndex');
        return <StandaloneTagsIndex {...mergeProps({ options: { theme } }, props)} />;
    }
}